export default __webpack_public_path__ + "static/us-enterprise-top-talent-6988e7df9bf3cee3f9a9c0f6269ba8d2.gif";